/**
 * 求人一覧 求人コンテンツリンクの画面表示情報
 * @property title タイトル文言
 * @property summary 説明文言
 */
interface JobContentLinkDisplay {
  title: string;
  summary: string;
}

// 求人コンテンツリンク種別キー
export type JobContentLinkKey = 'JobTrend' | 'Occupation';

// 求人コンテンツリンクの定義
export const JOB_CONTENT_LINK: Record<
  JobContentLinkKey,
  JobContentLinkDisplay
> = {
  JobTrend: {
    title: '求人の傾向',
    summary: 'dodaに掲載中の求人に関するデータを、カテゴリごとにご紹介します。',
  },
  Occupation: {
    title: '職業別の求人数',
    summary:
      'dodaに掲載中の求人に関するデータを、年収×職種ごとにグラフ形式でご紹介します。',
  },
} as const;
